// SPDX-License-Identifier: Apache-2.0
export const SEARCH_VISIBLE_PARAMETER = 'searchVisible';
export const BASEMAP_VISIBLE_PARAMETER = 'basemapVisible';
